import {ObjectDTO} from './object-dto';
import {ProduitDeclinaisonDTO} from './produit-declinaison-dto';

export class ProduitArticleDTO extends ObjectDTO {

  libelle: string;
  reference: string;
  produitDeclinaison: ProduitDeclinaisonDTO;
}
